
/*
 * Copyright (C) 2015 ICOS Group, Newcastle University.  All rights reserved.
 * Contact:  James Alastair McLaughlin <j.a.mclaughlin@ncl.ac.uk>
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions
 * are met:
 *  
 * 1. Redistributions of source code must retain the above copyright
 *    notice, this list of conditions and the following disclaimer.
 *  
 * 2. Redistributions in binary form must reproduce the above copyright
 *    notice, this list of conditions and the following disclaimer in the
 *    documentation and/or other materials provided with the distribution.
 * 
 * THIS SOFTWARE IS PROVIDED BY THE AUTHOR AND CONTRIBUTORS ``AS IS'' AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED.  IN NO EVENT SHALL THE AUTHOR OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS
 * OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
 * HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF
 * SUCH DAMAGE.
 */

"use strict";

var extend = require('extend');

module.exports = function serializeIdentified(sbolDocument, identified, tagName, properties) {

    var out = {};

    out.uri = identified.uri.toString();

    if(identified.persistentIdentity.toString() !== '')
        out.persistentIdentity = identified.persistentIdentity.toString();

    if(identified.displayId.toString() !== '')
        out.displayId = identified.displayId;

    if(identified.version.toString() !== '')
        out.version = identified.version;

    if(identified.wasDerivedFroms.length > 0) {
        out.wasDerivedFroms = identified.wasDerivedFroms.map(function(wasDerivedFrom) {
	    return wasDerivedFrom.uri?wasDerivedFrom.uri.toString():wasDerivedFrom.toString();
        });
    }

    if(identified.wasGeneratedBys.length > 0) {
        out.wasGeneratedBys = identified.wasGeneratedBys.map(function(wasGeneratedBy) {
	    return wasGeneratedBy.uri?wasGeneratedBy.uri.toString():wasGeneratedBy.toString();
        });
    }

    if(identified.name.toString() !== '')
        out.title = identified.title;

    if(identified.description.toString() !== '')
        out.description = identified.description;

    if(identified.annotations.length > 0) {
        out.annotations = identified.annotations;
    }

   	if(identified.attachments.length > 0) {
        out.attachments = identified.attachments.map(function(attachment) {
            return attachment.uri?attachment.uri.toString():attachment.toString();
        });
    }

    return out;
}


